import React from "react";
import styled from "styled-components";
import { Colors } from "../config";
import { Error } from "../config/StyledComponents";
import InputLabel from "./InputLabel";

const TextArea = ({
  name,
  placeholder,
  label,
  onChange,
  value,
  errorText,
  required,
  rows = 5,
  labelFontColor = Colors.coolGrey,
  labelFontSize = "1.125rem",
  labelFontWeight = 400,
}) => {
  return (
    <TextAreaWrapper>
      <InputLabel
        label={label}
        labelFontColor={labelFontColor}
        labelFontSize={labelFontSize}
        labelFontWeight={labelFontWeight}
        required={required}
      />
      <TextareaComponent
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        rows={rows}
        errorText={errorText}
      />
      {errorText && <Error>{errorText}</Error>}
    </TextAreaWrapper>
  );
};

export default TextArea;

const TextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TextareaComponent = styled.textarea`
  border: ${(props) =>
    props.errorText ? "1px solid" + Colors.red : "1px solid" + Colors.coolGrey};
  border-radius: 0.875rem;
  background-color: ${Colors.white};
  color: ${Colors.darkCharcoal};
  font-size: 0.875rem;
  resize: none;
  padding: 0.75rem;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  :focus{
    outline:none;
  }
  ::placeholder {
    color: ${Colors.sharkOpacity20};
    padding: 0.125rem;
    font-family: "Inter", sans-serif;
    font-weight: 600;
  }
  }
`;
